import * as React from "react";
import { Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { InviteData, InviteStatus } from "../../util/sendInvitaion";
import InfoIcon from "@mui/icons-material/Info";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { ReactComponent as SuccessIcon } from "fe-web-components/assets/successIcon.svg";
import ErrorIcon from "@mui/icons-material/Error";

//region [[ Styles ]]
const useStyles = makeStyles({
  inviteStatusChip: {
    display: "inline-flex",
    flexDirection: "row",
    border: "1px solid rgba(0, 0, 0, 0.23)",
    backgroundColor: "transparent",
    height: 32,
    outline: 0,
    fontSize: "0.8125rem",
    textAlign: "center",
    whiteSpace: "nowrap",
    borderRadius: 16,
    verticalAlign: "middle",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 12px",
    gap: 8,
    "& .chip-text": {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
    "& svg": {
      verticalAlign: "middle",
    },
    "&.chip-icon-start": {
      paddingLeft: 4,
    },
    "&.chip-icon-end": {
      paddingRight: 4,
    },
  },
  inviteToolTip: {
    marginTop: 6,
    display: "flex",
    flexDirection: "column",
    gap: 6,
    "& .method-status": {
      display: "flex",
      alignItems: "center",
      gap: 6,
    },
    "& svg": {
      width: 14,
      height: 14,
    },
  },
});

//endregion [[ Styles ]]
//region [[ Props ]]

export interface InviteStatusChipProps {
  invite: InviteData;
  disabled?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const InviteStatusChip = ({ ...props }: InviteStatusChipProps) => {
  const { statusList } = props.invite;
  const classes = useStyles();

  //no status
  if (!statusList)
    return (
      <span className={classes.inviteStatusChip}>
        <span className="chip-text">Not Sent</span>
      </span>
    );

  const statusMethods = Object.keys(statusList);
  //still sending
  if (
    statusMethods.some(
      (method) => statusList[method].status === InviteStatus.SendingStatus,
    )
  )
    return (
      <span className={`${classes.inviteStatusChip} chip-icon-end`}>
        <span className="chip-text">Sending</span>
        <MoreHorizIcon color="secondary" />
      </span>
    );

  return (
    <Tooltip
      title={statusMethods.map((method) => (
        <div key={method + props.invite.id} className="method-status">
          {statusList[method].status === InviteStatus.ErrorStatus ? (
            <ErrorIcon color={"error"} />
          ) : (
            <SuccessIcon />
          )}
          {statusList[method].msg}
        </div>
      ))}
      arrow={true}
      classes={{ tooltip: classes.inviteToolTip }}
    >
      <span className={`${classes.inviteStatusChip} chip-icon-start`}>
        {statusMethods.some(
          (method) => statusList[method].status === InviteStatus.ErrorStatus,
        ) ? (
          <>
            <InfoIcon color="secondary" />
            <span className="chip-text">Error</span>
          </>
        ) : (
          <>
            <SuccessIcon />
            <span className="chip-text">Sent</span>
          </>
        )}
      </span>
    </Tooltip>
  );
};
